{
  "CANNED_MGMT": {
    "HEADER": "Шаблонные ответы",
    "LEARN_MORE": "Подробнее о шаблонных ответах",
    "DESCRIPTION": "Шаблоны ответов - это предварительно написанные шаблоны ответов, которые помогут вам быстро в диалог. Агенты могут ввести символ '/', за которым следует команда, чтобы вставить готовый ответ во время диалога. ",
    "COUNT": "{n} шаблонный ответ | {n} шаблонных ответов",
    "HEADER_BTN_TXT": "Добавить шаблонный ответ",
    "LOADING": "Загружаем шаблонные ответы...",
    "SEARCH_PLACEHOLDER": "Поиск шаблонных ответов...",
    "NO_RESULTS": "Не найдены шаблонные ответы, соответствующие вашему запросу",
    "SEARCH_404": "Нет категорий, соответствующих запросу.",
    "LIST": {
      "404": "У вас нет шаблонных ответов.",
      "TITLE": "Управление шаблонными ответами",
      "DESC": "Шаблонные ответы – это заранее подготовленные шаблоны для быстрого ответа в диалогах.",
      "TABLE_HEADER": {
        "SHORT_CODE": "Команда",
        "CONTENT": "Текст",
        "ACTIONS": "Действия"
      }
    },
    "ADD": {
      "TITLE": "Добавить шаблонный ответ",
      "DESC": "Шаблонные ответы – это заранее подготовленные шаблоны для быстрого ответа в диалогах.",
      "CANCEL_BUTTON_TEXT": "Отменить",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Команда",
          "PLACEHOLDER": "Пожалуйста, введите команду.",
          "ERROR": "Команда обязательна."
        },
        "CONTENT": {
          "LABEL": "Сообщение",
          "PLACEHOLDER": "Пожалуйста, напишите сообщение, которое вы хотите сохранить как шаблон для использования позже.",
          "ERROR": "Необходимо ввести сообщение."
        },
        "SUBMIT": "Отправить"
      },
      "API": {
        "SUCCESS_MESSAGE": "Шаблонный ответ сохранен.",
        "ERROR_MESSAGE": "Не удалось подключиться к Woot серверу. Пожалуйста, попробуйте еще раз."
      }
    },
    "EDIT": {
      "TITLE": "Редактировать шаблонный ответ",
      "CANCEL_BUTTON_TEXT": "Отменить",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Команда",
          "PLACEHOLDER": "Пожалуйста, введите команду.",
          "ERROR": "Команда обязательна."
        },
        "CONTENT": {
          "LABEL": "Сообщение",
          "PLACEHOLDER": "Пожалуйста, напишите сообщение, которое вы хотите сохранить как шаблон для использования позже.",
          "ERROR": "Необходимо ввести сообщение."
        },
        "SUBMIT": "Отправить"
      },
      "BUTTON_TEXT": "Редактировать",
      "API": {
        "SUCCESS_MESSAGE": "Шаблонный ответ сохранен.",
        "ERROR_MESSAGE": "Не удалось подключиться к Woot серверу. Пожалуйста, попробуйте еще раз."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Удалить",
      "API": {
        "SUCCESS_MESSAGE": "Шаблонный ответ удален.",
        "ERROR_MESSAGE": "Не удалось подключиться к Woot серверу. Пожалуйста, попробуйте еще раз."
      },
      "CONFIRM": {
        "TITLE": "Подтвердите удаление",
        "MESSAGE": "Вы точно хотите удалить ",
        "YES": "Да, удалить ",
        "NO": "Нет, не удалять "
      }
    }
  }
}
